/** Download the one readable copy of recovery codes while they still exist. */
export function downloadRecoveryCodes(codes: readonly string[]): void {
  const blob = new Blob(['Staleless two-step sign-in recovery codes\n\n', codes.join('\n'), '\n'], {
    type: 'text/plain;charset=utf-8',
  })
  const url = URL.createObjectURL(blob)
  const anchor = document.createElement('a')
  anchor.href = url
  anchor.download = 'staleless-recovery-codes.txt'
  anchor.click()
  URL.revokeObjectURL(url)
}
